import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

class SliderPosts {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.slider-posts__swiper', {
      modules: [Pagination],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 24,
      grabCursor: true,
      preventInteractionOnTransition: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }, breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }
}

export const sliderPosts = new SliderPosts();
